export enum LocalStorageTypes {
    UserProfile = "userProfile",
    RecentFiles = "recentFiles",
    RecentSearches = "recentSearches",
    MyFiles = "myFiles"
}